import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "yellowTips" }, " 存在操作场景，暂无法实现获取正确的数据操作前内容，如发现缺失或有疑问，请找开发协助排查！ ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "存在以下比对差异不正确的场景：", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "1. 单独操作涉及多条数据：操作的接口后链路修改其他页面的数据，即A功能A数据的操作，改了B、C功能的B、C数据", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "2. 数据可以被其他页面操作修改的特殊场景：无新增操作，且无法获取主数据的编辑接口", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "3. 针对存在批量操作的数据，单独操作产生的日志", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "4. 接口没有记录操作内容的值", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "cursor-pointer text-blue-500" }, " 点击，查看场景说明 ", -1)
const _hoisted_8 = { class: "flex mt-4" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", { class: "font-medium text-sm w-6/12" }, " 操作前的内容： ", -1)
const _hoisted_10 = { class: "font-medium text-sm w-6/12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "当前操作的内容，操作后的内容只有id时，表示当前操作为删除类操作", -1)

import { isArray, isObject } from '@/utils/is'
import { type LogInfo } from '../type'
import { type Ref, ref, toRefs, watch } from 'vue'
import {
  Tooltip,
} from 'ant-design-vue'
import { CodeDiff } from 'v-code-diff';


export default /*#__PURE__*/_defineComponent({
  __name: 'diffTwo',
  props: {
    bizService: {},
    curMenuName: {},
    errorMsg: {},
    menuId: {},
    menuName: {},
    needDiff: {},
    opTime: {},
    opUser: {},
    userName: {},
    operation: {},
    operationBody: {},
    operationType: {},
    originSys: {},
    preOperationBody: {},
    successFlg: {},
    uniValue: {}
  },
  setup(__props: any) {

const props = __props
const { operationBody, preOperationBody } = toRefs(props)
const optBody = ref('')
const preOptBody = ref('')

const processValue = (value: string, targetStr: Ref<string>) => {
  if (value?.startsWith('{')) { // 是对象的时候，转换成key-value的形式，一行一个key，方便查看diff
    targetStr.value = '' // 重置
    const bodyObj = JSON.parse(value)
    Object.keys(bodyObj).sort()
      .forEach(key => {
        let value = ''
        if (isArray(bodyObj[key]) || isObject(bodyObj[key])) {
          value = JSON.stringify(bodyObj[key], null, 2)
        } else {
          value = String(bodyObj[key])
        }
        targetStr.value = targetStr.value + `${key}: ${value}\n`
      })
  } else {
    targetStr.value = value
  }
}

watch(
  () => operationBody.value,
  (value) => {
    processValue(value, optBody)
  },
  {
    immediate: true,
  },
)

watch(
  () => preOperationBody.value,
  (value) => {
    processValue(value, preOptBody)
  },
  {
    immediate: true,
  },
)

return (_ctx: any,_cache: any) => {
  const _component_InfoCircleOutlined = _resolveComponent("InfoCircleOutlined")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_unref(Tooltip), { trigger: "click" }, {
      title: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6
      ]),
      default: _withCtx(() => [
        _hoisted_7
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("h3", _hoisted_10, [
        _createVNode(_unref(Tooltip), null, {
          title: _withCtx(() => [
            _hoisted_11
          ]),
          default: _withCtx(() => [
            _createVNode(_component_InfoCircleOutlined)
          ]),
          _: 1
        }),
        _createTextVNode(" 操作后的内容： ")
      ])
    ]),
    _createVNode(_unref(CodeDiff), {
      "diff-style": "char",
      "max-height": 400,
      "new-string": optBody.value ?? props.operationBody,
      "old-string": preOptBody.value ?? props.preOperationBody,
      "output-format": "side-by-side"
    }, null, 8, ["new-string", "old-string"])
  ], 64))
}
}

})